import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Price from 'shopper/components/Price';
import Text from 'shopper/components/Text';

const ComparaiPriceMobile = ({ priceValue, storeTitle }) => (
  <Flex flexDirection="column" display={[null, null, 'none']}>
    <Price
      size="size3"
      primaryInfo={priceValue}
      secondaryInfo="à vista por"
      mt={[null, null, 4]}
    />
    <Text size="size2">{storeTitle}</Text>
  </Flex>
);

ComparaiPriceMobile.propTypes = {
  priceValue: PropTypes.string.isRequired,
  storeTitle: PropTypes.string.isRequired,
};

export default ComparaiPriceMobile;
